
import * as React from "react";
import * as S from "@styled";

import { ValidationError } from "../model/ValidationData";
import CreateEnvironmentVariableEditor from "./CreateEnvironmentVariableEditor";

export const ValidationErrorDisplay: React.FC<ValidationErrorDisplayProps> = (props) => {
    if (!props.errors || !props.errors.length) {
        return null;
    }
    return <>
        {props.errors.map((error, index) => {
            return (
                <S.FormGroup key={(error.parameterKey as string) + index} variant={S.FormGroupVariant.error}>
                    <div className="error">
                        {error.getMessageString()} <CreateEnvironmentVariableEditor error={error}/>
                    </div>
                </S.FormGroup>
            );
        })}
    </>;
};

interface ValidationErrorDisplayProps {
    errors: ValidationError[];
}
